import { useCallback, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { useCreateFolder } from '@nx-frontend/shared/hooks';
import { ContextMenuItemData, ContextMenuItemType } from '@nx-frontend/shared/types';

export const useGetFoldersAllDocsButtons = () => {
  const params = useParams();
  const slug = useMemo(() => params?.slug || [], [params?.slug]) as string[];

  const createFolder = useCreateFolder();

  const t = useTranslations('webnotes');

  return useCallback(() => {
    const [workspaceId, , globalId] = slug || [];
    return [
      {
        icon: IconsMap.DOCUMENT,
        title: t('webnotes-new_page'),
        subTitle: t('webnotes-new_page_description'),
        id: 'newPage',
      },
      {
        icon: IconsMap.FOLDER,
        title: 'root' === globalId ? t('webnotes-new_folder') : t('webnotes-new_subfolder'),
        subTitle: t('webnotes-new_folder_description'),
        id: 'newFolder',
        action: () => {
          createFolder({ parentId: globalId, workspaceId });
        },
      },
      // {
      //   icon: IconsMap.DOWNLOAD,
      //   title: 'Import',
      //   subTitle: 'Import from other platforms',
      //   id: 'import',
      // },
      {
        icon: IconsMap.TASKS_PLUS,
        title: t('webnotes-new_task'),
        subTitle: t('webnotes-new_task_description'),
        id: 'newTask',
      },
      {
        icon: IconsMap.TEMPLATE,
        title: t('webnotes-templates'),
        subTitle: t('webnotes-templates_description'),
        id: 'template',
      },
    ];
  }, [t, slug, createFolder]);
};

export const getMoreButtonMenu = (openModal: () => void) => {
  return [
    {
      title: 'Upload files',
      icon: IconsMap.PAPERCLIP,
      type: ContextMenuItemType.DEFAULT,
      additionalStyles: 'w-[186px]',
    },

    {
      title: 'Rename',
      icon: IconsMap.EDIT,
      type: ContextMenuItemType.DEFAULT,
      isSeparator: true,
    },

    {
      title: 'Add to Favourites',
      icon: IconsMap.BOOKMARK,
      type: ContextMenuItemType.DEFAULT,
    },

    {
      title: 'Duplicate',
      icon: IconsMap.COPY,
      type: ContextMenuItemType.DEFAULT,
    },
    {
      title: 'Move to/Copy to',
      icon: IconsMap.MOVE_TO,
      type: ContextMenuItemType.DEFAULT,
      isSeparator: true,
    },

    {
      title: 'Open in new tab',
      icon: IconsMap.LOG_OUT_2,
      type: ContextMenuItemType.DEFAULT,
    },

    {
      title: 'Share',
      icon: IconsMap.ARROW_REPLY_1,
      type: ContextMenuItemType.DEFAULT,
    },

    {
      title: 'Copy link',
      icon: IconsMap.LINK_1,
      type: ContextMenuItemType.DEFAULT,
      isSeparator: true,
    },
    {
      title: 'Delete',
      icon: IconsMap.TRASH,
      type: ContextMenuItemType.DEFAULT,
      isSeparator: true,
    },

    {
      title: 'Manage members',
      icon: IconsMap.PERSONS,
      type: ContextMenuItemType.DEFAULT,
      textStyleClasses: 'font-bold text-cyan-500',
      iconStyles: '!text-cyan-500',
    },
  ] as ContextMenuItemData[];
};
